import React, { useEffect } from "react";
import AOS from "aos";
import { Link } from "react-router-dom";
import {
  AutoFixHigh,
  AutoMode,
  PriceCheck,
  Build,
  Speed,
  SupportAgent,
} from "@mui/icons-material";
import "aos/dist/aos.css"; // If using AOS (Animate On Scroll) library
import "./ServicesSection.css"; // Import the CSS file

const ServicesSection = () => {
  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  const services = [
    {
      icon: (
        <AutoFixHigh sx={{ color: "#e84545", fontSize: "3rem", mt: "3px" }} />
      ),
      title: "Modern Design",
      description:
        "Our design approach emphasizes creating visually appealing, intuitive, and user-friendly interfaces. We focus on modern aesthetics and ensure that each element serves a functional purpose, leading to a seamless user experience.",
      delay: "",
    },
    {
      icon: <Speed sx={{ color: "#e84545", fontSize: "3rem", mt: "2px" }} />,
      title: "High Performance",
      description:
        "Our solutions are optimized to deliver top-notch performance. We carefully refine every aspect of our services to ensure fast loading times, responsive interactions, and consistent reliability, even under heavy loads.",
      delay: "100",
    },
    {
      icon: <AutoMode sx={{ color: "#e84545", fontSize: "3rem", mt: "2px" }} />,
      title: "Flexible Layout",
      description:
        "Our layouts are designed to adapt seamlessly to various screen sizes and devices. Whether it's a mobile phone, tablet, or desktop, our flexible design ensures that your content looks great and functions perfectly across all platforms.",
      delay: "200",
    },
    {
      icon: (
        <SupportAgent sx={{ color: "#e84545", fontSize: "3rem", mt: "2px" }} />
      ),
      title: "Free Support",
      description:
        "We offer free support to assist you with any issues or questions. Our dedicated support team is always ready to help you, ensuring that you maximize the value of our services without incurring any additional costs.",
      delay: "300",
    },
    {
      icon: (
        <PriceCheck sx={{ color: "#e84545", fontSize: "4rem", mt: "15px",ml:'4px' }} />
      ),
      title: "Cool Pricing",
      description:
        "Our pricing plans are competitive and transparent, perfectly suited to your budget. We design our pricing to provide the best value for your investment, with no hidden fees or unexpected charges.",
      delay: "400",
    },
    {
      icon: (
        <Build sx={{ color: "#e84545", fontSize: "2.5rem", mt: "10px",rotate:'100deg' }} />
      ),
      title: "Custom Solutions",
      description:
        "Our tailored approach ensures that you receive solutions precisely aligned with your unique business needs. We specialize in creating custom software that addresses your specific challenges, enhancing efficiency and driving growth.",
      delay: "500",
    },
  ];

  return (
    <div className="site-section">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center" data-aos="zoom-out-up">
            <h2 className="heading font-weight-bold mb-3">Our Services</h2>
          </div>
        </div>
        <div className=" parent-services" >
          {services.map((service, index) => (
            <div key={index} className="one-sevice"data-aos="zoom-in-up">
              <div className="unit-4 d-flex">
                <div className="unit-4-icon mr-4">{service.icon}</div>
                <div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <p>
                    <Link to={"/About"}>Learn More</Link>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;